module.exports = __webpack_public_path__ + "static/media/unbound2.907e104d.png";